import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

const withTipoFornecimento = (routes: any[], utlTipoFornecimentoId: number): any[] =>
  routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      utlTipoFornecimentoId
    },
    children: route.children ? withTipoFornecimento(route.children, utlTipoFornecimentoId) : route.children
  }));

const routes = [
  {
    description: '4. Laudo de Cabos',
    path: 'laudo',
    name: 'laudoCabos',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo de Cabos',
    path: 'laudo/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertCabos',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoCabos',
      utlTipoFornecimentoId: 206,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Edição de Laudo de Cabos',
    path: 'laudo/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateCabos',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoCabos',
      utlTipoFornecimentoId: 206,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Revisão de Laudo de Cabos',
    path: 'revisao-laudo',
    name: 'revisaoLaudoCabos',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Aprovacao_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: '1. Recebimento de Cabos',
    path: 'recebimento',
    name: 'recebimentocabos',
    component: () => import('@/views/utilidade/recebimento/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Recebimento de Cabos',
    path: 'recebimento/incluir',
    name: 'recebimentocabosinsert',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Recebimento de Cabos',
    path: 'recebimento/editar/:id',
    name: 'recebimentocabosupdate',
    component: () => import('@/views/utilidade/recebimento/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: '2. Aplicação de Cabos',
    path: 'aplicacao',
    name: 'aplicacaocabos',
    component: () => import('@/views/utilidade/aplicacao-ambiente/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Aplicacao],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Aplicação de Cabos',
    path: 'aplicacao/incluir',
    name: 'inclusaoaplicacaocabos',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Aplicação de Cabos',
    path: 'aplicacao/editar/:protocolo',
    name: 'aplicacaocabosupdate',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: '3. Ensaio de Cabos',
    path: 'ensaio',
    name: 'ensaiocabos',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Cabos',
    path: 'ensaio/incluir',
    name: 'InclusaoEdicaoEnsaioCabos',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaiocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: 'Estoque de Cabos',
    path: 'estoque',
    name: 'estoquecabos',
    component: () => import('@/views/utilidade/estoque/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Estoque],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Lote de Cabos',
    path: 'lote',
    name: 'produtofornecedorlotecabos',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Lote de Cabos',
    path: 'lote/incluir?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorlotecabosinsert',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotecabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Lote de Cabos',
    path: 'lote/editar/:id?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorlotecabosupdate',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotecabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatorios',
    goesToMenu: false,
    children: relatorios
  }
];

export default [
  {
    path: 'cabos',
    description: 'Cabos',
    meta: {
      utlTipoFornecimentoId: 206
    },
    goesToMenu: false,
    children: withTipoFornecimento(routes, 206)
  }
];
